module.exports = __webpack_public_path__ + "static/media/1.Servicing Machine.5173a834.jpg";